import { createSelector } from 'reselect';
import { RootStateType } from '../rootReducer';

export const selectSearchResults = (state: RootStateType) => state.search.results;

export const selectSearchQuery = (state: RootStateType) => state.search.query;

export const selectSearchVOD = createSelector(selectSearchResults, (search) => search.vod);

export const selectSearchChannels = createSelector(
  selectSearchResults,
  (search) => search.channels,
);

export const selectSearchPrograms = createSelector(
  selectSearchResults,
  (search) => search.programs,
);
